import React from 'react'
import classnames from 'classnames'

export default function Button({variants, children, className, is = 'button', ...props}) {
  const variantClassNames = (variants || []).map(v => 'button--' + v);
  const Type = is;
  return (
    <Type {...props} className={classnames(className, 'button', variantClassNames)}>
      {children}
    </Type>
  )
}


// WEBPACK FOOTER //
// ./client/components/Button/index.js